import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingMarkAsVoidedAtom = createMutationAtomFactory(
  'trade.bookingMarkAsVoided',
  (params: { id: string; forceUnlink?: boolean }) => ({
    tradeBookingVoid: {
      __args: {
        id: params.id,
        forceUnlink: params.forceUnlink,
      },
      booking: {
        id: true,
        documentNumber: true,
        status: true,
      },
      blockingLoads: {
        id: true,
        documentNumber: true,
      },
      unlinkableLoads: {
        id: true,
        documentNumber: true,
      },
      requiresConfirmation: true,
    },
  }),
);
